import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { notifications } from '../../actions/auth/auth';
import endpoint from '../../config/Axios';
import { apis } from '../../config/APIs';
import { useState } from 'react';
import LazyLoading from './Lazyloading';

const Notifications = ({ onClose }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [data, setData] = useState();
  const [page, setPage] = useState(1);
  const notifications_res = useSelector(state => state?.auth?.notifications?.data?.response?.notification)
  const loading = useSelector(state => state?.auth?.notifications?.loading)
  const total_records = useSelector(state => state?.auth?.notifications?.data?.total_records)
  const itemsRef = React.useRef();
  const is_admin = useSelector((state) => state?.auth?.localVariables?.is_admin);

  const handleClickOutside = (event) => {
    if (
      (itemsRef.current && itemsRef.current.contains(event.target)) ||
      event.target.className === "inputSelect"
    ) {
      return;
    }
    onClose()
  };


  useEffect(() => {
    if (is_admin)
      dispatch(notifications());
    else
      dispatch(notifications({ is_employee: true }))
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
    // eslint-disable-next-line
  }, [is_admin])

  useEffect(() => {
    if (
      notifications_res &&
      !loading &&
      notifications_res.length > 0
    ) {
      if (page === 1) {
        setData(notifications_res);
      } else {
        setData((d) => [...d, ...notifications_res]);
      }
    }
    // eslint-disable-next-line
  }, [notifications_res]);

  const goToPage = (page, id) => {
    switch (page) {
      case "advance":
        history.push("/advance-details/" + id)
        break;
      case "report":
        history.push("/report-details/" + id)
        break;
      case "trip":
        history.push("/trip-details/" + id)
        break;
      default:
        break;
    }
  }
  return (
    <ul className='notifications' ref={itemsRef}>
      {data?.length ? data?.map((ele) => <li className={`${ele.seen ? "" : "unseen"}`} onClick={() => {
        const formData = new FormData()
        formData.append("id", ele.id)
        endpoint.put(apis.update_notification, formData).then(() => {
          if (is_admin)
            dispatch(notifications());
          else
            dispatch(notifications({ is_employee: true }))
        })
        goToPage(ele?.data?.page, ele?.data?.id);
        onClose()
      }}>
        <label>{ele.title}</label>
        <p style={{ textAlign: "start" }}>{ele.body}</p>
      </li>) : <div className="no-data">
        <span>No Data</span>
      </div>}
      <LazyLoading
        loading={loading}
        data={data}
        isLastPage={data?.length === total_records}
        onPagination={() => {
          if (!loading && data?.length < total_records) {
            setPage(page => page + 1);
            if (is_admin)
              dispatch(notifications({
                page: page + 1,
              }));
            else
              dispatch(notifications({ is_employee: true, page: page + 1, }))
          }
        }}
      />
    </ul>
  );
};

export default Notifications;